import { VisitorConfig } from './types';

export const initialVisitorConfig: VisitorConfig = {
  heroTitle: "CONCEPTS CULINAIRES SINGULIERS & IMMERSIFS",
  heroSubtitle: "Aujourd'hui, les participants à un événement ne veulent plus seulement bien manger, ils veulent vivre une expérience mémorable. C'est pour répondre à ce besoin que nous avons créé feed-it.",
  brandColor: "#D95D39", // Premium Terracotta color from High Density Theme
  brandLogoText: "feed-it",
  brandLogoUrl: "",
  brandLogoDarkUrl: "",
  brandLogoHeightPx: 40,
  brandLogoAlt: "",
  logoPlacement: "menu",
  bottomRightLogoUrl: "",
  showBottomRightLogo: false,
  bottomRightLogoWidthPercent: 15,
  chatButtonEnabled: false,
  chatButtonWhatsappNumber: "",
  chatButtonIconUrl: "",
  chatButtonText: "Discutez avec nous",
  chatButtonMessage: "Bonjour, j'aimerais avoir des renseignements.",
  cookieBannerEnabled: true,
  googleTagId: "",
  cookieBannerText:
    "Ce site utilise des cookies techniques nécessaires à son fonctionnement. Aucun cookie de mesure d'audience ou publicitaire n'est déposé sans votre consentement.",
  contactPhone: "06 86 36 78 38",
  hidePhoneInHeader: false,
  contactAddress: "15 Rue Tupin, 69600 Oullins",
  contactEmail: "contact@feed-it.fr",
  aboutText: "Créateur de scénographies culinaires et d'émotions gourmandes sur-mesure pour mariages, cocktails dînatoires, dîners gastronomiques et fêtes privées.",
  services: [
    {
      id: "serv-1",
      title: "Cocktails Dînatoires Créatifs",
      description: "Des pièces cocktail travaillées comme des œuvres d'art, alliant textures surprenantes et goûts intenses.",
      image: "https://images.unsplash.com/photo-1541532713592-79a0317b6b77?q=80&w=800",
      category: "Cocktails"
    },
    {
      id: "serv-2",
      title: "Dîners Gastronomiqes Immersifs",
      description: "Une table d'exception servie à l'assiette avec un dressage d'art et des mariages de saveurs uniques.",
      image: "https://images.unsplash.com/photo-1544025162-d76694265947?q=80&w=800",
      category: "Mariages"
    },
    {
      id: "serv-3",
      title: "Live Cooking & Ateliers",
      description: "Nos chefs préparent en direct sous vos yeux des animations de woks fumants, fumages minute ou découpes d'exception.",
      image: "https://images.unsplash.com/photo-1555126634-323283e090fa?q=80&w=800",
      category: "Événements"
    },
    {
      id: "serv-4",
      title: "Brunchs Gourmands & Locaux",
      description: "Le réconfort parfait du lendemain de fête : brioches artisanales, oeufs parfaits, charcuteries lyonnaises et jus pressés.",
      image: "https://images.unsplash.com/photo-1541518763669-27fef04b14ea?q=80&w=800",
      category: "Family Parties"
    }
  ],
  universes: [
    {
      id: "univ-mariages",
      name: "Mariages",
      tagline: "Co-célébrer",
      description: "Buffets scénographiés, dressages en longueur et pièces montées revisitées pour le plus long des dîners.",
      color: "#D95D39",
      image: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?q=80&w=800",
      visible: true
    },
    {
      id: "univ-cocktails",
      name: "Cocktails",
      tagline: "Co-recevoir",
      description: "Pièces cocktail travaillées comme des œuvres, bar à cocktails fumants et service à la volée.",
      color: "#C9A227",
      image: "https://images.unsplash.com/photo-1541532713592-79a0317b6b77?q=80&w=800",
      visible: true
    },
    {
      id: "univ-evenements",
      name: "Événements",
      tagline: "Co-construire",
      description: "Séminaires, lancements de marque et dîners de gala : une logistique invisible, une table mémorable.",
      color: "#4A5859",
      image: "https://images.unsplash.com/photo-1555126634-323283e090fa?q=80&w=800",
      visible: true
    },
    {
      id: "univ-family",
      name: "Family Parties",
      tagline: "Co-partager",
      description: "Brunchs de lendemain, anniversaires et tablées familiales : le raffinement sans la raideur.",
      color: "#7A9E7E",
      image: "https://images.unsplash.com/photo-1541518763669-27fef04b14ea?q=80&w=800",
      visible: true
    },
    {
      id: "univ-food-truck",
      name: "Food Truck",
      tagline: "Co-rouler",
      description: "Notre cuisine mobile s'installe où vous voulez : street-food chic, plancha marine et desserts minute, servis au comptoir.",
      color: "#2F6D80",
      image: "https://images.unsplash.com/photo-1565123409695-7b5ef63a2efb?q=80&w=800",
      visible: true
    }
  ],
  showUniversesSection: true,
  universesTitle: "NOS UNIVERS CULINAIRES",
  universesSubtitle: "CHAQUE OCCASION A SA CUISINE",

  socialLinks: {
    instagram: "",
    linkedin: "",
    facebook: "",
    tiktok: "",
    production: "",
    productionLabel: "Notre atelier de production"
  },

  googleReviews: {
    enabled: true,
    placeUrl: "",
    rating: 4.9,
    reviewsCount: 150,
    highlightQuote: "Un accompagnement exceptionnel, une équipe rigoureuse et des saveurs culinaires incroyables. Recommandé à 100% pour vos mariages.",
    highlightAuthor: "Avis Google vérifié"
  },

  ctaLabel: "Collaborons",

  prestations: [
    {
      id: "prest-1",
      title: "CONVIVIALITÉ",
      category: "Street-Food Chic",
      image: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?q=80&w=800",
      description: "Nos fameux burgers gourmets élaborés avec du bœuf charolais, du cheddar affiné local et notre sauce secrète.",
      tag: "Événements d'entreprise & Lendemain de fête"
    },
    {
      id: "prest-2",
      title: "ÉMOTION",
      category: "Le Grand Buffet",
      image: "https://images.unsplash.com/photo-1555244162-803834f70033?q=80&w=800",
      description: "Dressages artistiques en longueur, cascades de fruits de saison et découpes de tartes géantes réalisées devant vos convives.",
      tag: "Mariages d'exception"
    },
    {
      id: "prest-3",
      title: "QUALITÉ",
      category: "Live Cook Premium",
      image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?q=80&w=800",
      description: "Saisies de fruits de mer premium à haute flamme, assaisonnements aux herbes fraîches et agrumes bio pour un goût pur.",
      tag: "Cocktails haut de gamme"
    },
    {
      id: "prest-4",
      title: "MOBILITÉ",
      category: "Food Truck",
      image: "https://images.unsplash.com/photo-1565123409695-7b5ef63a2efb?q=80&w=800",
      description: "Notre camion-cuisine s'installe dans la cour, au domaine ou sur le parvis : service au comptoir, cuisson minute, zéro compromis sur le produit.",
      tag: "Lancements de marque & fêtes en extérieur"
    }
  ],
  quoteFields: [
    {
      id: "eventType",
      type: "radio",
      label: "Quel type d'événement organisez-vous ?",
      required: true,
      options: ["Mariage d'exception", "Cocktail Privé", "Dîner de Gala", "Séminaire / Entreprise"],
      optionsBranching: [
        { text: "Mariage d'exception", nextQuestionId: "mariageTheme" },
        { text: "Cocktail Privé", nextQuestionId: "cocktailAteliers" },
        { text: "Dîner de Gala", nextQuestionId: "guestsCount" },
        { text: "Séminaire / Entreprise", nextQuestionId: "entrepriseFormat" }
      ],
      defaultNextQuestionId: "guestsCount"
    },
    {
      id: "mariageTheme",
      type: "checkbox",
      label: "Quelle ambiance souhaitez-vous pour votre mariage ?",
      required: false,
      options: ["Romantique & Floral", "Château Chic", "Champêtre Écoresponsable", "Minimaliste Contemporain"],
      defaultNextQuestionId: "guestsCount"
    },
    {
      id: "cocktailAteliers",
      type: "checkbox",
      label: "Quels ateliers de découpe / live-cooking souhaitez-vous intégrer ?",
      required: false,
      options: ["Découpe de Jambon Ibérique Pata Negra", "Plancha Marine & Coquillages", "Bar à Cocktails Fumants", "Desserts Haute Couture en direct"],
      defaultNextQuestionId: "guestsCount"
    },
    {
      id: "entrepriseFormat",
      type: "select",
      label: "Quel est le format d'événement attendu ?",
      required: true,
      options: ["Conférence & Cocktail", "Lancement de Produit", "Dîner d'Affaires VIP", "Teambuilding Culinaire"],
      defaultNextQuestionId: "guestsCount"
    },
    {
      id: "guestsCount",
      type: "number",
      label: "Combien d'invités attendez-vous ?",
      placeholder: "Ex: 120",
      required: true,
      defaultNextQuestionId: "eventDate"
    },
    {
      id: "eventDate",
      type: "date",
      label: "Quelle est la date prévue de l'événement ?",
      required: true,
      defaultNextQuestionId: "budget"
    },
    {
      id: "budget",
      type: "radio",
      label: "Quel budget par personne envisagez-vous ?",
      required: true,
      options: ["70€ - 100€", "100€ - 150€", "150€ - 250€", "Prestige sur-mesure (>250€)"],
      defaultNextQuestionId: "message"
    },
    {
      id: "message",
      type: "textarea",
      label: "Parlez-nous de vos envies particulières",
      placeholder: "Décrivez l'atmosphère, le lieu, des restrictions alimentaires...",
      required: false
    }
  ],
  mediaGallery: [
    {
      id: "med-1",
      type: "video",
      url: "https://assets.mixkit.co/videos/preview/mixkit-chef-preparing-a-fresh-vegetable-salad-41584-large.mp4",
      title: "Spectacle en Cuisine",
      description: "Nos chefs dressent en direct des créations culinaires d'exception."
    },
    {
      id: "med-2",
      type: "image",
      url: "https://images.unsplash.com/photo-1543007630-9710e4a00a20?q=80&w=800",
      title: "Créations Culinaires",
      description: "Des dressages élégants alliant textures raffinées et saveurs intenses."
    },
    {
      id: "med-3",
      type: "video",
      url: "https://assets.mixkit.co/videos/preview/mixkit-pouring-red-wine-into-a-glass-41703-large.mp4",
      title: "Service Sommelier",
      description: "Accords mets-vins de prestige pour sublimer chaque plat de la soirée."
    },
    {
      id: "med-4",
      type: "image",
      url: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?q=80&w=800",
      title: "Scénographies de Tables",
      description: "Une atmosphère immersive conçue sur-mesure pour votre concept."
    }
  ],
  mediaLayout: "slider",
  showMediaSection: true,
  themeStyle: "orange_studio",
  customEventTypesText: "ÉVÈNEMENTS\nMARIAGES\nCOCKTAILS\nFAMILY PARTIES\n...",
  customPlayfulSubtext: "Des évènements comme ça !",

  // 1. Hero Default configuration (Customizable)
  heroMode: "slider",
  heroSlides: [
    {
      id: "slide-1",
      image: "https://images.unsplash.com/photo-1544025162-d76694265947?q=80&w=1600",
      title: "CONCEPTS CULINAIRES SINGULIERS",
      subtitle: "ART DE LA TABLE & HAUTE SCÉNOGRAPHIE",
      description: "Pour vos réceptions privées et mariages d'exception en région Rhône-Alpes et Suisse.",
      buttonText: "Collaborons",
      buttonSecondaryText: "Notre Univers",
      textColor: "#ffffff",
      contentPosition: "left"
    },
    {
      id: "slide-2",
      image: "https://images.unsplash.com/photo-1555244162-803834f70033?q=80&w=1600",
      title: "CRÉATEUR D'ÉMOTIONS GOURMANDES",
      subtitle: "LIVE COOKING & THÉÂTRE DE SAVEURS",
      description: "Des chefs étoilés s'installent chez vous ou dans le lieu de votre choix pour des ateliers de haut vol.",
      buttonText: "Collaborons",
      buttonSecondaryText: "Galerie Médias",
      textColor: "#ffffff",
      contentPosition: "center"
    },
    {
      id: "slide-3",
      image: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?q=80&w=1600",
      title: "UNE SIGNATURE ENGAGÉE",
      subtitle: "100% LOCAL & CIRCUITS ULTRA-COURTS",
      description: "Nous travaillons exclusivement avec des producteurs lyonnais et des artisans locaux passionnés.",
      buttonText: "Demander notre catalogue",
      buttonSecondaryText: "Nos Fournisseurs",
      textColor: "#ffffff",
      contentPosition: "right"
    }
  ],
  heroAutoplay: true,
  heroAutoplaySpeed: 5000,
  heroEffect: "ken_burns",
  heroVideoUrl: "https://assets.mixkit.co/videos/preview/mixkit-chef-preparing-a-fresh-vegetable-salad-41584-large.mp4",
  heroVideoType: "mp4",
  heroVideoOverlayOpacity: 0.5,
  heroOverlayColor: "#000000",
  heroOverlayOpacity: 0.3,
  heroOverlayGradient: "linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.2) 100%)",

  // 2. Header default configuration
  headerScrollBg: "glass",

  // 3. Enable state for all sections by default
  showPresentationSection: true,
  showServicesSection: true,
  showRealisationsSection: true,
  showChiffresSection: true,
  showAvisSection: true,
  showPartenairesSection: true,
  showFaqSection: true,
  showContactSection: true,

  // 4. Section specific pre-loaded content
  presentationTitle: "L'EXPÉRIENCE FEED-IT",
  presentationSubtitle: "AU-DELÀ DE LA GASTRONOMIE : UNE VÉRITABLE SCÉNOGRAPHIE CULINAIRE",
  presentationText: "Chaque bouchée est pensée comme un dialogue entre le goût, l'espace et vos invités. Nos chefs, sculpteurs de saveurs et artisans de lumière, dressent des buffets artistiques de saison pour transformer votre événement lyonnais ou suisse en une exposition vivante d'émotions gourmandes. Plus qu'un traiteur, nous sommes des créateurs d'ambiance.",
  presentationMediaType: "image",
  presentationMediaUrl: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?q=80&w=800",

  statsItems: [
    { id: "stat-1", label: "Événements Réussis", number: 180, suffix: "+", description: "Cocktails, mariages et lancements de marques" },
    { id: "stat-2", label: "Clients Comblés", number: 9200, suffix: "+", description: "Particuliers exigeants et entreprises renommées" },
    { id: "stat-3", label: "Années d'Expérience", number: 8, suffix: " ans", description: "De créativité culinaire ininterrompue à Lyon" },
    { id: "stat-4", label: "Note Globale Google", number: 4.9, suffix: "/5", description: "Basé sur 150+ avis vérifiés et enthousiastes" }
  ],

  testimonials: [
    { id: "test-1", name: "Maxime Bernard", company: "Mariage en Beaujolais", rating: 5, text: "Une prestation incroyable ! La cascade de fruits de saison et les dressages géants en longueur ont laissé nos 120 convives totalement bouche bée. Un immense bravo à l'équipe de feed-it pour leur écoute.", photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=150" },
    { id: "test-2", name: "Sarah Claret", company: "Cabinet Novis", rating: 5, text: "Dans le cadre de notre lancement de marque, les ateliers de Live Cooking haut de gamme avec fumage minute ont conquis tous nos clients. Le professionnalisme est impeccable et le goût exceptionnel !", photo: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=150" },
    { id: "test-3", name: "Thibault Meyer", company: "Dîner Privé d'Anniversaire", rating: 5, text: "Un chef d'exception directement dans notre cuisine pour un dîner privé à 20 convives. Un raffinement digne des plus grands étoilés, tout en restant simple et extrêmement chaleureux.", photo: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=150" }
  ],

  partnerLogos: [
    { id: "p-1", name: "Domaine de la Ruche", logoUrl: "https://images.unsplash.com/photo-1532634922-8fe0b757fb13?q=80&w=100" },
    { id: "p-2", name: "Château des Vignes", logoUrl: "https://images.unsplash.com/photo-1543007630-9710e4a00a20?q=80&w=100" },
    { id: "p-3", name: "Hôtel Lyon Lumières", logoUrl: "https://images.unsplash.com/photo-1517841905240-472988babdf9?q=80&w=100" },
    { id: "p-4", name: "Suisse Premium Chalets", logoUrl: "https://images.unsplash.com/photo-1566073771259-6a8506099945?q=80&w=100" }
  ],

  faqItems: [
    { id: "faq-1", question: "Quelles sont vos zones géographiques d'intervention ?", answer: "Nous nous déplaçons principalement dans toute la métropole de Lyon, la région Rhône-Alpes, ainsi qu'en Suisse (Genève, Lausanne). D'autres déplacements sont envisageables sur devis spécifique." },
    { id: "faq-2", question: "Proposez-vous des options végétariennes ou adaptées aux allergies ?", answer: "Absolument. Lors de la saisie de votre devis libre ou lors de notre premier appel logistique, vous pourrez mentionner toutes les contraintes alimentaires. Nos chefs adaptent sur-mesure chaque pièce cocktail et plat." },
    { id: "faq-3", question: "Comment se déroule la validation des fournisseurs ?", answer: "Une fois votre simulation validée, nous affectons les meilleurs artisans locaux (Jean-Louis pour les viandes de pays, Sophie pour la sommellerie fine...). Vous pouvez suivre et approuver leurs offres en direct depuis votre espace client." },
    { id: "faq-4", question: "Sous quel délai obtenons-nous une estimation tarifaire ?", answer: "Notre simulateur de devis vous donne un code dossier de suivi immédiat. L'administrateur de feed-it chiffre et propose une offre finale détaillée sous moins de 24 heures." }
  ],

  // 5. Stylistic presets
  btnStyle: "plein",
  enableCustomCursor: true,
  enableNoiseEffect: false,
  enableMagneticButtons: true
};

/**
 * Complète une configuration enregistrée par les valeurs par défaut.
 *
 * La configuration est un document JSON figé le jour de son dernier
 * enregistrement. Sans ce complément, toute rubrique ajoutée ensuite — les
 * univers culinaires, les liens sociaux, les avis Google — restait absente
 * pour les agences déjà en service, et le site affichait des sections vides
 * jusqu'à une réouverture du back-office.
 *
 * Seules les clés ABSENTES sont complétées : une liste vidée volontairement
 * depuis le back-office reste vide.
 */
export function withConfigDefaults(stored: Partial<VisitorConfig> | null | undefined): VisitorConfig {
  if (!stored) return initialVisitorConfig;
  return {
    ...initialVisitorConfig,
    ...stored,
    socialLinks: { ...initialVisitorConfig.socialLinks, ...(stored.socialLinks || {}) },
    googleReviews: { ...initialVisitorConfig.googleReviews, ...(stored.googleReviews || {}) },
    // Les univers sont la charpente des filtres : une liste absente casse la
    // navigation, alors qu'une liste vidée est un choix éditorial assumé.
    universes: stored.universes ?? initialVisitorConfig.universes,
  };
}
